
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_21455","data-name":"Group 21455","transform":"translate(-1026.967 -921.047)"}},[_c('g',{attrs:{"id":"Group_21454","data-name":"Group 21454"}},[_c('rect',{attrs:{"id":"Rectangle_7314","data-name":"Rectangle 7314","width":"22","height":"22","rx":"5","transform":"translate(1026.967 921.047)","fill":"#f4f5fd"}})]),_c('rect',{attrs:{"id":"Rectangle_7316","data-name":"Rectangle 7316","width":"15","height":"8","rx":"1.5","transform":"translate(1030.967 928.546)","fill":"none","stroke":"#5b6474","stroke-width":"1"}}),_c('line',{attrs:{"id":"Line_483","data-name":"Line 483","x2":"5","transform":"translate(1032.467 930.546)","fill":"none","stroke":"#5b6474","stroke-linecap":"round","stroke-width":"1"}}),_c('line',{attrs:{"id":"Line_485","data-name":"Line 485","x2":"2","transform":"translate(1040.467 930.546)","fill":"none","stroke":"#5b6474","stroke-linecap":"round","stroke-width":"1"}}),_c('line',{attrs:{"id":"Line_484","data-name":"Line 484","x2":"6","transform":"translate(1032.967 932.547)","fill":"none","stroke":"#5b6474","stroke-linecap":"round","stroke-width":"1"}}),_c('line',{attrs:{"id":"Line_486","data-name":"Line 486","x2":"1","transform":"translate(1032.467 934.546)","fill":"none","stroke":"#5b6474","stroke-linecap":"round","stroke-width":"1"}}),_c('line',{attrs:{"id":"Line_487","data-name":"Line 487","x2":"8","transform":"translate(1034.967 934.546)","fill":"none","stroke":"#5b6474","stroke-linecap":"round","stroke-width":"1"}})])])
          )
        }
      }
    